import React, { useState } from 'react';
import { useStoreContext } from '../../store/context';
import { Box, Button, Collapse, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { fieldSampleGroupEditor, formatPhoneNumber } from '../../store/common';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { StyledTableCellBinary, StyledTableRow2 } from 'src/shared/Styles/Styles';
import ExpandableText from 'src/shared/ExpandableText/ExpandableText';
import DeleteIcon from '@mui/icons-material/Delete';
  
    /*Row to populate the header and sample portion */  
type ContactRowProps ={
    allParams: any
    deleteContactResponse: (contactId: any) => Promise<void>; 
  }
  export const ContactRow:React.FC<ContactRowProps> = ({
    allParams,
    deleteContactResponse,
  }) => {
        const getNames = (nameType: string, array: any[] )=>{
      if(array){
        return array?.map(a=>a[nameType])?.join(', ')
      }
      else{
        return ''
      }
    }

    const [state] = useStoreContext();

    const handleDelete = (contactId: any) => {
      deleteContactResponse(contactId);
    };

    const [openAccordion, setOpenAccordion] = useState(allParams.contact?.openContactAccordion);
    const areaNames = getNames('areaName', allParams.contact.areas);
    const groupNames = getNames('groupName', allParams.contact.groups);
    const isDeleteDisabled = !!areaNames || !!groupNames;

    return (
      <>
        <StyledTableRow2 sx={{ '& > *': { borderBottom: 'unset' } }}>
          <StyledTableCellBinary>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => {setOpenAccordion(!openAccordion)}}
              >
                   {openAccordion ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
              </IconButton>
          </StyledTableCellBinary>
          <StyledTableCellBinary className='text-align-override' tabIndex={0}>
            {allParams.contact.contactName}
          </StyledTableCellBinary>
          <StyledTableCellBinary className='text-align-override' tabIndex={0}>
            <ExpandableText text={getNames('areaName', allParams.contact.areas)} maxWords={3} fontSize="14px"/>
          </StyledTableCellBinary>
          <StyledTableCellBinary className='text-align-override' tabIndex={0}>
            <ExpandableText text={getNames('groupName', allParams.contact.groups)} maxWords={3} fontSize="14px"/>
          </StyledTableCellBinary>
          <StyledTableCellBinary className='text-align-override capitalize' tabIndex={0}>
            {allParams.contact.contactExtension? `${formatPhoneNumber(allParams.contact.contactPhone)} ext.${allParams.contact.contactExtension}`:`${formatPhoneNumber(allParams.contact.contactPhone)}`}
          </StyledTableCellBinary>
          <StyledTableCellBinary className='text-align-override' tabIndex={0}>
            {allParams.contact.contactEmail}
          </StyledTableCellBinary>
          <StyledTableCellBinary >
                {
                  state.user && (fieldSampleGroupEditor(state.user)) &&
                  <div style={{ display: 'flex', gap: '8px' }}>
                      <Tooltip title={ "Edit Contact" } placement="top-start">
                            <Button variant="outlined" style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white'}} onClick={()=>allParams.editContact(allParams.contact)}>
                                  <EditIcon />
                            </Button>
                      </Tooltip>
                      <Tooltip
                            title={isDeleteDisabled ? "Please disassociate this Contact from being an Area or Group Owner before deleting" : "Delete Contact"}
                            placement="top-start"
                          >
                            <span>
                              <Button
                                variant="outlined"
                                color="error"
                                style={{ minWidth: '0', paddingRight: '2px', paddingLeft: '2px', backgroundColor: 'white' }}
                                onClick={() => (handleDelete(allParams.contact.contactId))}
                                disabled={isDeleteDisabled}
                              >
                                <DeleteIcon />
                              </Button>
                            </span>
                      </Tooltip>
                  </div>
                }
          </StyledTableCellBinary>
        </StyledTableRow2>  
        <TableRow>
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
                <Collapse in={openAccordion} timeout="auto" unmountOnExit>
                      <Box sx={{ marginLeft: 10, marginTop: 1, marginBottom: 1, marginRight: 1 }}>
                        <Table size="small" aria-label="sites" component={Paper}>
                            <colgroup>
                                <col width="25%" />
                                <col width="75%" />
                            </colgroup>
                            <TableHead>
                                <TableRow style={{backgroundColor: '#575757', color: 'white'}}>
                                  <TableCell style={{color: 'white'}} className='text-align-override' tabIndex={0}>LOCATION</TableCell>
                                  <TableCell style={{color: 'white'}} tabIndex={0}>TITLE</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                      <TableRow>
                                        <TableCell className="text-align-override padding5"tabIndex={0}>
                                          {allParams.contact.location || ''}
                                        </TableCell>
                                        <TableCell className="padding5" tabIndex={0}>
                                          {allParams.contact.title || ''}
                                        </TableCell>
                                      </TableRow>
                            </TableBody>
                        </Table>
                      </Box>
                </Collapse>
            </TableCell>
        </TableRow>
      </>
    );
  };